export default __webpack_public_path__ + "static/media/DigitalUtility.d4d082cb.gif";